import {fieldConditionHelper} from "@/form/helpers/field-conditionals.js";

let steps = [
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: '__cc_debt_amount__',
        fields: [
            {
                // label: 'Credit Card Debt Amount',
                name: 'cc_debt_amount',
                placeholder: '2500',
                as: 'input',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_debt_amounts_5000_less__", "value":"5000" },
                    { "text":"__opt_debt_amounts_5001_10000__", "value":"7500" },
                    { "text":"__opt_debt_amounts_10001_15000__", "value":"10000" },
                    { "text":"__opt_debt_amounts_15001_20000__", "value":"15000" },
                    { "text":"__opt_debt_amounts_20001_25000__", "value":"20000" },
                    { "text":"__opt_debt_amounts_25000_more__", "value":"25000" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: '__unsecured_debt_amount__',
        textTop: '__unsecured_debt_amount_definition__',
        fields: [
            {
                // label: 'Total Other Unsecured Debt',
                name: 'unsecured_debt_amount',
                placeholder: '2500',
                as: 'input',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_debt_amounts_5000_less__", "value":"5000" },
                    { "text":"__opt_debt_amounts_5001_10000__", "value":"7500" },
                    { "text":"__opt_debt_amounts_10001_15000__", "value":"10000" },
                    { "text":"__opt_debt_amounts_15001_20000__", "value":"15000" },
                    { "text":"__opt_debt_amounts_20001_25000__", "value":"20000" },
                    { "text":"__opt_debt_amounts_25000_more__", "value":"25000" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__address__",
        fields: [
            {
                // addressLabel: null,
                name: 'address',
                placeholder: '',
                as: 'input',
                type: 'fulladdress',
                fieldOuterClass: 'col-md-8 offset-md-2',
                value: null,
                // validationRules: 'required',
            },
        ],
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__income_type__",
        fields: [
            {
                // label: 'Income Source',
                name: 'income_type',
                placeholder: '__income_type__',
                as: 'input',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_income_type_full__", "value":"full_time" },
                    { "text":"__opt_income_type_part__", "value":"part_time" },
                    { "text":"__opt_income_type_self__", "value":"self_employed" },
                    { "text":"__opt_income_type_benefits__", "value":"social_security" },
                    { "text":"__opt_income_type_disability__", "value":"disability" },
                    { "text":"__opt_income_type_pension__", "value":"retired" },
                    { "text":"__opt_income_type_unemployed__", "value":"unemployed" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__monthly_income__",
        fields: [
            {
                // label: 'Monthly Income',
                name: 'monthly_income',
                placeholder: '2500',
                // prependInputSpan: '$',
                // appendInputSpan: '.00',
                as: 'input',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_1500_less__", "value":"1500" },
                    { "text":"__opt_1501_2000__", "value":"2000" },
                    { "text":"__opt_2001_3000__", "value":"3000" },
                    { "text":"__opt_3001_4000__", "value":"4000" },
                    { "text":"__opt_4001_5000__", "value":"5000" },
                    { "text":"__opt_5000_more__", "value":"5500" },
                ],
                attrs: {
                    maxlength: 5
                },
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    {

        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__own_home__",
        fields: [
            {
                // label: 'Are you a homeowner?',
                name: 'own_home',
                placeholder: '',
                as: 'input',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_yes__", "value":"yes" },
                    { "text":"__opt_no__", "value":"no" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        // hideIfCondition: (app) => {
        //     var options = [
        //         'ON','BC','QC'
        //     ];
        //     return !app.address || !app.address.province || !options.includes(app.address.province);
        // }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__living_situation__",
        fields: [
            {
                label: '__rent_mortgage_payment__',
                name: 'rent_mortgage_payment',
                placeholder: '1400',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-6 offset-md-3',
                attrs: {
                    maxlength: 6
                },
            },
            {
                label: '__property_value__',
                name: 'property_value',
                placeholder: '650000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-6 offset-md-3',
                attrs: {
                    maxlength: 7
                },
                hideIfHasValue: true,
                hideIfCondition: (app) => {
                    return fieldConditionHelper.homeOwner(app);
                },
            },
            {
                label: '__property_mortgage__',
                name: 'property_mortgage',
                placeholder: '300000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-6 offset-md-3',
                attrs: {
                    maxlength: 7
                },
                hideIfHasValue: true,
                hideIfCondition: (app) => {
                    return fieldConditionHelper.homeOwner(app);
                },
            },
        ],
        // hideIfCondition: (app) => {
        //     var options = [
        //         'ON','BC','QC'
        //     ];
        //     return !app.address || !app.address.province || !options.includes(app.address.province);
        // }
    },
    {
        beforeCreate: function() {
            // console.log('beforeCreate');
        },
        beforeNextStep: function() {
            // console.log('beforeNextStep');
        },
        title: "__in_credit_situation__",
        fields: [
            {
                // label: 'Loan Purpose',
                // name: 'credit_score',
                name: 'in_credit_situation',
                placeholder: '__select__',
                as: 'input',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"text": "__opt_in_credit_situation_good__", "value": "good"},
                    {"text": "__opt_in_credit_situation_fair__", "value": "fair"},
                    {"text": "__opt_in_credit_situation_low__", "value": "low"},
                    {"text": "__opt_in_credit_situation_cp__", "value":"in_consumer_proposal"},
                    {"text": "__opt_in_credit_situation_bk__", "value":"in_bankruptcy"},
                    {"text": "__opt_in_credit_situation_unknown__", "value": "unknown"},
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        // isStepReadOnly: true,
        // isStepEditable: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__citizen_status__",
        fields: [
            {
                // label: 'Citizenship Status',
                name: 'canadian_status',
                placeholder: '',
                as: 'input',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_cs_citizen__", "value":"citizen" },
                    { "text":"__opt_cs_permanent__", "value":"pr" },
                    { "text":"__opt_cs_work__", "value":"work_permit" },
                    { "text":"__opt_cs_student__", "value":"student_visa" },
                    { "text":"__opt_cs_visitor__", "value":"other" },
                    { "text":"__opt_cs_other__", "value":"other" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__dob__",
        fields: [
            {
                // label: 'What is your date of birth?',
                name: 'dob',
                placeholder: null,
                as: 'input',
                type: 'date',
                value: null,
                validationRules: 'required|dob',
                fieldOuterClass: 'col-md-6 offset-md-3',
                attrs: {
                    maxlength: 10
                },
                hideIfHasValue: false,
            },
        ],
    },
    {
        // beforeCreate: 'enablePartialRequestPerStep',
        beforeCreate: function() {},
        // beforeNextStep: 'executeEmailRegistrationCheck',
        // beforeNextStep: 'executeSubmitApplication',
        beforeNextStep: function() {},
        title: "__how_to_contact__",
        fields: [
            {
                label: '__first_name__',
                name: 'first_name',
                // placeholder: 'First Name',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: false,
            },
            {
                label: '__last_name__',
                name: 'last_name',
                // placeholder: 'Last Name',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: false,
            },
            {
                label: '__email_address__',
                name: 'email',
                // placeholder: '__your_email__',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|email',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                }
            },
            {
                label: '__phone_number__',
                name: 'phone_number',
                // placeholder: 'Your phone number',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|canadianPhone',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 10
                },
                hideIfHasValue: true,
                textBottom: '__phone_number_sms_results__'
            },
            {
                // label: 'Credit Auth',
                label: false,
                name: 'opt_in',
                placeholder: '',
                as: 'input',
                type: 'checkbox',
                value: null,
                // validationRules: 'required',
                // fieldOuterClass: 'col-md-10 offset-md-1',
                fieldInnerClass: 'large-checkbox',
                // choices: [
                //     { "text":'__opt_opt_in_consent__', "value":true },
                // ]
                choices: (app) => {
                    if(app.projectBrandKey) {
                        if(app.projectBrandKey == 'lc') {
                            return [
                                { "text":'__opt_opt_in_consent__', "value":true },
                            ];
                        }
                        else if(app.projectBrandKey == 'comparehub') {
                            return [
                                { "text":'__opt_opt_in_consent_by_lc__', "value":true },
                            ];
                        }
                    }

                    return [
                        { "text":'__opt_opt_in_consent_by_comparehub__', "value":true },
                    ];
                },
            },
        ],
        // nextButtonText: '__submit__',
        // textBottom: '<p class="text-muted" style="font-size:14px;">By continuing with this form, you consent, acknowledge, and agree to our <a href="https://loanscanada.ca/privacy-policy" target="_blank">privacy policy</a> including your application data being shared with Loans Canada\'s partner(s) (see third-party vendor list <a href="https://loanscanada.ca/third-party-vendor-list/" target="_blank">here</a>), data stored outside of the province of Quebec, and Loans Canada and/or its other partners contacting you by phone, SMS (charges may apply depending on your carrier, not by us, messaging frequency varies; text HELP for help; text STOP to cancel) or e-mail to respond to (or request feedback from) your request. You can opt-out at any time.</p>'
        textBottomBelowActionButtons: "__credit_history_authorization_1__"
    },
    {
        beforeCreate: function() {},
        beforeNextStep: 'executeSubmitApplication',
        title: "__sms_verification__",
        fields: [
            {
                // label: 'SMS Verification',
                name: 'sms_verification',
                type: 'smsverification',
                value: null,
                hideSubtitles: true,
            },
        ],
        hideButtonsSection: true,
        nextButtonText: '__skip__',
        nextButtonClass: 'btn-secondary',
        hideIfCondition: (app) => {
            return !app.forceSmsVerification;
        }
    },
];

export default steps;
